import { useEffect } from 'react'
import GA from 'react-ga'
import { useLocation } from 'react-router-dom'
import { useOrganization } from 'src/core/graphql/hooks'

const trackerName = 'organizationGATracker'

const useGoogleAnalytics = () => {
   const { organization } = useOrganization()
   const location = useLocation()

   // Initialize Google Analytics
   // (This also handles cases when GA is enabled/disabled mid-session)
   useEffect(() => {
      if (organization?.tmpGoogleAnalyticsTrackingId) {
         GA.initialize(organization.tmpGoogleAnalyticsTrackingId, {
            debug: false,
            name: trackerName
         })

         // Fire initial pageview event
         GA.pageview(location.pathname)
      } else if (organization) {
         // If GA was previously turned on, and now it is not, remove the current tracker
         const ga = GA.ga()
         if (ga) {
            ga(() => {
               const tracker = ga.getByName(trackerName)
               if (tracker) {
                  ga.remove(trackerName)
               }
            })
         }
      }
   }, [organization?.tmpGoogleAnalyticsTrackingId])

   // Fire Google Analytics pageview event whenver location changes
   useEffect(() => {
      if (organization?.tmpGoogleAnalyticsTrackingId) {
         GA.pageview(location.pathname)
      }
   }, [location.pathname])
}

export default useGoogleAnalytics
